module.exports = __webpack_public_path__ + "img/img_cx5.32b089a7.jpg";